"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _ = _interopRequireWildcard(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _Translations = require("react-platform-components/dist/Translations");
var _excluded = ["setSubmitting"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * This class contains the dialog that has the form
 * it will handle: the fetching of some informations in it's (if needed),
 * showing the form and submiting it.
 *
 * Use it with injectToBaseCreationDialog to provide these props:
 *  - componentDidMount - NEEDS to be a function expression and NOT an arrow function
 *  - endpoint
 *  - excludedFields
 *  - customHandleSubmit
 *  - createForm
 *  - editTitle
 *  - title
 *  - submitAction - the action to trigger to submit the form
 *      NEEDS to be a function expression and NOT an arrow function
 *  - handleSubmit - This will be passed to the form to handle submit
 *      NOTE: it will provide the props (like dispatch) inside the this
 *      of the function. and it NEEDS to be a function expression and NOT an arrow function
 *
 * other props are passed from BaseContainer
 *
 * TODO: We'll need to find a solution on how to manage excludedFields and customHandleSubmit
 * when injecting to a form other then BaseForm whithout the need to always redefine
 * all of excludedFields and customHandleSubmit
 */
var BaseCreationDialog = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseCreationDialog, _React$Component);
  var _super = _createSuper(BaseCreationDialog);
  function BaseCreationDialog() {
    var _this;
    _classCallCheck(this, BaseCreationDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (values, _ref) {
      var setSubmitting = _ref.setSubmitting,
        props = _objectWithoutProperties(_ref, _excluded);
      var _this$props = _this.props,
        isEdit = _this$props.isEdit,
        selectedProduct = _this$props.selectedProduct,
        close = _this$props.close;
      var data = _objectSpread(_objectSpread({}, values), {}, {
        user: _this.props.user.id
      });
      var formData = new FormData();
      var excludedFields = [];

      // This endpoint is used in the action (edit/create)
      var endpoint = _this.props.endpoint || 'products';
      var postUpdateAction = _this.props.postUpdateAction || 'FETCH_PRODUCTS';

      // Add the excludedFields provided from the props
      // these keys are excluded from the loop that appends to the formData
      // and are handeled in customHandleSubmit
      if (_this.props.excludedFields) {
        _this.props.excludedFields.forEach(function (key) {
          return excludedFields.push(key);
        });
      }
      _.forOwn(data, function (value, key) {
        if (excludedFields.indexOf(key) !== -1) {
          return;
        } else if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });

      // Check if a customHandleSubmit function is provided and excute it
      // it takes the data to use it to append to our formData
      if (_this.props.customHandleSubmit) {
        _this.props.customHandleSubmit(data, formData);
      }
      if (_this.props.submitAction) {
        _this.props.submitAction.bind(_assertThisInitialized(_this))(formData);
      } else {
        if (isEdit) {
          _this.props.dispatch({
            type: 'UPDATE_PRODUCT',
            endpoint: endpoint,
            close: close,
            postUpdateAction: postUpdateAction,
            model: formData,
            id: selectedProduct.id,
            page: _this.props.pagination.page
          });
        } else {
          _this.props.dispatch({
            type: 'ADD_PRODUCT',
            endpoint: endpoint,
            close: close,
            postUpdateAction: postUpdateAction,
            model: formData,
            page: 1
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleConfirm", function () {
      _this.submitForm();
    });
    _defineProperty(_assertThisInitialized(_this), "bindSubmitForm", function (submitForm) {
      _this.submitForm = submitForm;
    });
    return _this;
  }
  _createClass(BaseCreationDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Check if a componentDidMount function is provided and excute it
      // we pass it the props so the function can use them to dispatch the actions
      if (this.props.componentDidMount) {
        this.props.componentDidMount.bind(this)();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        isEdit = _this$props2.isEdit,
        selectedProduct = _this$props2.selectedProduct,
        close = _this$props2.close,
        open = _this$props2.open,
        title = _this$props2.title,
        editTitle = _this$props2.editTitle,
        handleSubmit = _this$props2.handleSubmit;
      var product = isEdit ? selectedProduct : {};
      var CreateResourceForm = this.props.createForm;
      return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
        open: open,
        onClose: close,
        fullWidth: true,
        PaperProps: {
          style: {
            margin: 8,
            width: '100%'
          }
        }
      }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        variant: "inherit"
      }, isEdit ? /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: editTitle ? editTitle : 'Modifier Produit'
      }) : /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: title ? title : 'Créer Produit'
      }))), /*#__PURE__*/_react.default.createElement(_core.DialogContent, null, /*#__PURE__*/_react.default.createElement(CreateResourceForm, _extends({
        handleSubmit: handleSubmit ? handleSubmit : this.handleSubmit,
        bindSubmitForm: this.bindSubmitForm,
        product: product
      }, this.props))), /*#__PURE__*/_react.default.createElement(_core.DialogActions, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
        onClick: close
      }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Annuler"
      })), /*#__PURE__*/_react.default.createElement(_core.Button, {
        color: "primary",
        variant: "contained",
        onClick: this.handleConfirm,
        style: {
          margin: '0.5rem'
        }
      }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Confirmer"
      }))));
    }
  }]);
  return BaseCreationDialog;
}(_react.default.Component);
var _default = BaseCreationDialog;
exports.default = _default;